import React from 'react';
import { useTranslation } from 'react-i18next';

import infoIcon from '../../../assets/petDemos/info.svg';

import styles from './CodeReSentNotification.module.css';

const CodeReSentNotification = () => {
  const { t } = useTranslation('petDemos');

  return (
    <div className={styles.mainContainer}>
      <img alt="" src={infoIcon} />

      <p>{t('certificateLinking.authorizationCodeScreen.codeSent')}</p>
    </div>
  );
};

export { CodeReSentNotification };
